"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.NavDropdown = exports.withNavDropdownEvents = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Popup = _interopRequireDefault(require("./Popup"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Context = require("./Context");

var _NavItem = _interopRequireDefault(require("./NavItem"));

var _NavTooltip = _interopRequireDefault(require("./NavTooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var NavDropdown = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(NavDropdown, _React$PureComponent);

  var _super = _createSuper(NavDropdown);

  function NavDropdown() {
    var _this;

    (0, _classCallCheck2["default"])(this, NavDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", function () {
      var _this$props = _this.props,
          onOpen = _this$props.onOpen,
          setHasOpenMenu = _this$props.setHasOpenMenu;

      if (typeof onOpen === 'function') {
        onOpen();
      }

      setHasOpenMenu(true);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClose", function () {
      var _this$props2 = _this.props,
          onClose = _this$props2.onClose,
          setHasOpenMenu = _this$props2.setHasOpenMenu;

      if (typeof onClose === 'function') {
        onClose();
      }

      setHasOpenMenu(false);
    });
    return _this;
  }

  (0, _createClass2["default"])(NavDropdown, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          hover = _this$props3.hover,
          inverted = _this$props3.inverted,
          isActive = _this$props3.isActive,
          isOpen = _this$props3.isOpen,
          label = _this$props3.label,
          pinned = _this$props3.pinned,
          position = _this$props3.position,
          tooltip = _this$props3.tooltip,
          banner = _this$props3.banner,
          onMouseOver = _this$props3.onMouseOver,
          onMouseOut = _this$props3.onMouseOut,
          onFocus = _this$props3.onFocus,
          onBlur = _this$props3.onBlur;

      var content = /*#__PURE__*/_react["default"].createElement("div", {
        className: "nav-dropdown-trigger",
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onFocus: onFocus,
        onBlur: onBlur
      }, label);

      var wrapperClassName = (0, _classnames["default"])("cloud-ui-nav-menu ".concat(className), {
        'with-banner': banner
      });
      return /*#__PURE__*/_react["default"].createElement(_Popup["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_NavItem["default"], {
          isActive: isActive,
          isOpen: isOpen,
          className: className,
          "data-qa": 'nav-dropdown-trigger'
        }, tooltip ? /*#__PURE__*/_react["default"].createElement(_NavTooltip["default"], {
          className: className,
          trigger: content,
          position: position,
          open: !isOpen && hover,
          inverted: inverted
        }, tooltip) : content),
        className: wrapperClassName,
        popper: {
          className: "cloud-ui-nav-menu-popper ".concat(wrapperClassName)
        },
        on: "click",
        pinned: pinned,
        position: position,
        open: isOpen,
        onClose: this.onClose,
        onOpen: this.onOpen,
        inverted: inverted,
        "data-qa": "nav-dropdown-menu"
      }, children);
    }
  }]);
  return NavDropdown;
}(_react["default"].PureComponent);

var withNavDropdownEvents = function withNavDropdownEvents(WrappedComponent) {
  var _temp;

  return _temp = /*#__PURE__*/function (_React$PureComponent2) {
    (0, _inherits2["default"])(_temp, _React$PureComponent2);

    var _super2 = _createSuper(_temp);

    function _temp() {
      var _this2;

      (0, _classCallCheck2["default"])(this, _temp);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _super2.call.apply(_super2, [this].concat(args));
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "state", {
        isOpen: false,
        hover: false
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "onClose", function () {
        _this2.setState({
          isOpen: false,
          hover: false
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "onOpen", function () {
        _this2.setState({
          isOpen: true,
          hover: false
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "onMouseOver", function () {
        _this2.setState({
          hover: true
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "onMouseOut", function () {
        _this2.setState({
          hover: false
        });
      });
      return _this2;
    }

    (0, _createClass2["default"])(_temp, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, this.props, this.state, {
          onClose: this.onClose,
          onOpen: this.onOpen,
          onMouseOver: this.onMouseOver,
          onMouseOut: this.onMouseOut,
          onFocus: this.onMouseOver,
          onBlur: this.onMouseOut
        }));
      }
    }]);
    return _temp;
  }(_react["default"].PureComponent), _temp;
};

exports.withNavDropdownEvents = withNavDropdownEvents;

var NavDropdownWrapper = function NavDropdownWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement(_Context.ContextConsumer, null, function (_ref) {
    var setHasOpenMenu = _ref.setHasOpenMenu,
        banner = _ref.banner;
    return /*#__PURE__*/_react["default"].createElement(NavDropdown, (0, _extends2["default"])({}, props, {
      setHasOpenMenu: setHasOpenMenu,
      banner: banner
    }));
  });
};

exports.NavDropdown = NavDropdownWrapper;

var _default = withNavDropdownEvents(NavDropdownWrapper);

exports["default"] = _default;